import walidacjaCeny from '@components/form/validation/field/cena'
import validated from '@components/form/validation/validated'

export default validated({
    t: 'Cena',
    name: 'cena',
    type: 'number',

}, walidacjaCeny)